<template>
    <main class="main-content">
        <slot></slot>
    </main>
</template>

<script>
	export default {
		name: 'MainContent'
	}
</script>

<style lang="scss" scoped>
    main {
        background: #fff;
        border: 1px solid #f5f5f5;
        padding: 30px;
    }
</style>
